import { render, staticRenderFns } from "./preview-video.vue?vue&type=template&id=c8e6d8dc&scoped=true"
import script from "./preview-video.vue?vue&type=script&lang=js"
export * from "./preview-video.vue?vue&type=script&lang=js"
import style0 from "./preview-video.vue?vue&type=style&index=0&id=c8e6d8dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e6d8dc",
  null
  
)

export default component.exports